export const glyphs = 'https://cdn.ons.gov.uk/maptiles/osm/fontsv1/{fontstack}/{range}.pbf';
export const sprite = 'https://bothness.github.io/ons-basemaps/data/sprite';
export const def = [
	"EPSG:27700",
	"+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs"
];

export const mapLayers = [
	{
    'id': 'zoomstack-outdoor',
    'name': 'OS Zoomstack (outdoor style)',
    'url': './data/style-outdoor.json'
  },
  {
    'id': 'zoomstack-roads',
    'name': 'OS Zoomstack (roads style)',
    'url': './data/style-roads.json'
  },
  {
    'id': 'zoomstack-ons',
    'name': 'OS Zoomstack (ONS style)',
    'url': './data/style-os.json'
  },
  {
    'id': 'ons-light',
    'name': 'OpenMapTiles (ONS style)',
    'url': './data/style-omt.json'
  },
  {
    'id': 'ons-dark',
    'name': 'OpenMapTiles (ONS dark)',
    'url': './data/style-dark.json'
  },
  {
    'id': 'os-1900',
    'name': 'Ordnance Survey 1900s',
    'url': './data/style-os-1900.json'
  },
  {
    'id': 'os-1937',
    'name': 'Ordnance Survey 1937-61',
    'url': './data/style-os-1937.json'
  },
  {
    'id': 'esri',
    'name': 'ESRI Satellite Imagery',
    'url': './data/style-esri.json'
  },
  {
    'id': 'openstreetmap',
    'name': 'OpenStreetMap',
    'url': './data/style-osm.json'
	},
  {
    'id': 'roads-overlay',
    'name': 'OS Roads 2020',
    'url': './data/style-overlay.json',
		'overlay': true
	},
  {
    'id': 'bldg-overlay',
    'name': 'OS Buildings 2020',
    'url': './data/style-buildings.json',
		'overlay': true,
		'middle': true
	}
];